/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'fabric.emoji.add.custom.emoji.label': 'Fügen Sie Ihr eigenes Emoji hinzu',
  'fabric.emoji.add.label': 'Emoji hinzufügen',
  'fabric.emoji.cancel.label': 'Abbrechen',
  'fabric.emoji.categories.label': 'Emoji-Kategorie auswählen',
  'fabric.emoji.categories.search.results': 'Suchergebnisse',
  'fabric.emoji.category.activity': 'Aktivität',
  'fabric.emoji.category.all.uploads': 'Alle Uploads',
  'fabric.emoji.category.flags': 'Flaggen',
  'fabric.emoji.category.foods': 'Essen und Trinken',
  'fabric.emoji.category.frequent': 'Häufig',
  'fabric.emoji.category.nature': 'Natur',
  'fabric.emoji.category.objects': 'Objekte',
  'fabric.emoji.category.people': 'Personen',
  'fabric.emoji.category.places': 'Reisen und Orte',
  'fabric.emoji.category.productivity': 'Atlassian und Produktivität',
  'fabric.emoji.category.symbols': 'Symbole',
  'fabric.emoji.category.user.uploads': 'Ihre Uploads',
  'fabric.emoji.choose.file.screenReaderDescription':
    'Wählen Sie eine Datei für das Emoji. JPG, PNG oder GIF. Max. Größe: 1 MB.',
  'fabric.emoji.choose.file.title': 'Datei auswählen',
  'fabric.emoji.delete.description': 'Alle existierenden Instanzen dieses Emojis werden durch {emojiShortName} ersetzt',
  'fabric.emoji.delete.label': 'Entfernen',
  'fabric.emoji.delete.screenreader.tooltip':
    'Wenn Sie das {shortName}-Emoji löschen möchten, drücken Sie die Rücktaste.',
  'fabric.emoji.delete.title': 'Emoji entfernen',
  'fabric.emoji.delete.tooltip': 'Löschen',
  'fabric.emoji.emojipicker.emoi.roledescription': 'Emoji-Schaltfläche',
  'fabric.emoji.emojipicker.error': 'Fehler',
  'fabric.emoji.error.delete.failed': 'Entfernen fehlgeschlagen',
  'fabric.emoji.error.image.too.big': 'Das ausgewählte Bild hat mehr als 1 MB',
  'fabric.emoji.error.invalid.image': 'Das ausgewählte Bild ist ungültig.',
  'fabric.emoji.error.upload.failed': 'Upload fehlgeschlagen',
  'fabric.emoji.error.upload.timeout': 'Zeitlimit bei Upload überschritten',
  'fabric.emoji.image.requirements': 'JPG, PNG oder GIF. Max. Größe 1 MB.',
  'fabric.emoji.name.ariaLabel': 'Geben Sie einen Namen für das neue Emoji ein.',
  'fabric.emoji.picker': 'Emoji-Auswahl',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Suchergebnisse} other {Emojis}}',
  'fabric.emoji.pickerlist.tabpanel': 'Panel mit Emojis, Aktionen und Liste',
  'fabric.emoji.placeholder': 'z. B. Guten Tag',
  'fabric.emoji.preview': 'Ihr neues Emoji {emoji} sieht toll aus',
  'fabric.emoji.preview.title': 'Vorschau',
  'fabric.emoji.retry.label': 'Wiederholen',
  'fabric.emoji.search.label': 'Name des Emojis',
  'fabric.emoji.search.placeholder': 'Suchen',
  'fabric.emoji.search.status': 'Alle Emojis werden angezeigt',
  'fabric.emoji.search.status.count': '{count} Emojis gefunden',
  'fabric.emoji.select.skin.list.ariaLabel': 'Auswahl der Hautfarbe',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Wählen Sie eine Hautfarbe aus – {selectedTone} ausgewählt',
};
